import Typography from "@material-ui/core/Typography";
import SimPrimariaFilter from "./sim-primaria-filter/SimPrimariaFilter";
import {useEffect, useState} from "react";
import {filterPrimaria} from "./sim-primaria-filter/SimPrimariaFilterHelper";
import {updateObject} from "../../../../../../../../../../shared/utils/updateObject";
import FilterHistory from "../../../../../../../../../../shared/components/filter-history/FilterHistory";
import SortingDropdown from "../../../../../../../../../../shared/components/sorting-dropdown/SortingDropdown";
import {Button, Grid} from "@material-ui/core";
import {sortingCriteria} from "./ActivationSelectSimHelper";
import PropTypes from "prop-types";
import SimPrimariaTable from "./sim-primaria-table/SimPrimariaTable";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../../../../../../../../../store";

const ActivationSelectSimContent = (props) => {
    const [sort, setSort] = useState(`${sortingCriteria[0].value},desc`);
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [filterHistory, setFilterHistory] = useState(filterPrimaria)
    const [areAllSelected, setAreAllSelected] = useState(false);
    const customerId = useSelector(state => state.authReducer.selectedCompany.integrationId)
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.getSimPrimariaTableData(customerId, filterHistory, page, rowsPerPage, sort))
    }, [customerId, dispatch, filterHistory, page, rowsPerPage, sort])

    const handleFilterSearch = (name, value) => {
        setPage(0);
        setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
            [name]: {
                ...currentFilterHistory[name],
                value: value
            }
        }))
    }

    const handleFilterSelectsSearch = (value) => {
        setPage(0);
        setFilterHistory(prevFilterHistory => updateObject(prevFilterHistory, value))
    }

    const handleRemoveBadge = (key, type, index) => {
        setPage(0);
        setFilterHistory(filterHistory => updateObject(filterHistory, {
            [key]: {
                ...filterHistory[key],
                value: type === "primitive" ? "" : [...filterHistory[key].value].filter((i, idx) => idx !== index)
            }
        }))
    }

    const handleResetFilter = () => {
        setPage(0);
        setFilterHistory(filterPrimaria);
    }

    const handleTablePaginationChange = (page, rowsPerPage) => {
        setPage(page);
        setRowsPerPage(rowsPerPage);
    }

    return (
        <>
            <Typography variant="body2">a cui associare questa SIM</Typography>
            <SimPrimariaFilter
                handleSearchIcon={handleFilterSearch}
                filter={filterHistory}
                handleSelectSearch={handleFilterSelectsSearch}
            />
            <FilterHistory filter={filterHistory}
                           removeFilter={handleRemoveBadge}
                           resetFilter={handleResetFilter}/>
            <Grid container spacing={1}>
                <Grid container item justifyContent={"space-between"}>
                    <SortingDropdown sortingValue={sort}
                                     changeSortingCriteria={setSort}
                                     sortingCriteria={sortingCriteria}/>
                    <Button color={"primary"}
                            disabled={props.selected.length !== 1}
                            onClick={props.handleSetStep}
                            variant={"contained"}>Conferma</Button>
                </Grid>
                <SimPrimariaTable
                    page={page}
                    rowsPerPage={rowsPerPage}
                    selected={props.selected}
                    setSelected={props.setSelected}
                    areAllSelected={areAllSelected}
                    setAreAllSelected={setAreAllSelected}
                    handlePaginationChange={handleTablePaginationChange}/>
            </Grid>
        </>
    )
}

ActivationSelectSimContent.propTypes = {
    handleSetStep: PropTypes.func.isRequired,
    selected: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            numeroDiTelefono: PropTypes.string,
            seriale: PropTypes.string,
            dataOrdineDiConsegna: PropTypes.string,
            numeroOrdineDiConsegna: PropTypes.string
        })
    ).isRequired,
    setSelected: PropTypes.func.isRequired,
}

export default ActivationSelectSimContent;